// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff4747, #ecf0f1",
  darkColors: "#01244d, #013b34, #704202, #310045, #690000, #24363b",
  firstName: "Mohammed",
  middleName: "",
  lastName: "Gberejaye",
  message1: " Tech for social good. ",
  message2: "Frontend | Backend | Fullstack. ",
  icons: [
    {
      // Changes to be made here.
      image: "fa-github",
      url: "https://github.com/MuhammadGB",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/gberejayemd/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/mohammed-gberejaye/",
    },
    {
      image: "fa-twitter",
      url: "https://twitter.com/GberejayeM",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/shadowProfile.jpg"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/shadowProfile.jpg"),
  imageSize: 375,
  message:
    "My name is Mohammed Gberejaye. I am a Fullstack engineer and I am most passionate about building appealing interfaces for the web. In my free time I like to work on open source projects. I also love joining communities, helping and mentoring new developers, and supporting organizations to promote their growth with my skills and experiences.",
  resume: require("../editable-stuff/Résumé.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Personal Projects",
  gitHubUsername: "MuhammadGB", // Changes to be made here.
  reposLength: 0,
  specificRepos: [
    //"My-Reads",
    "Movie-App",
    "e-commerce",
    "Would_You_Rather_Game",
  ],
  otherRepos: {
    show: true,
    gitHubUser: "ghoshnirmalya",
    repoName: ["react-search-box"],
  },
};

const publicRepo = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "MuhammadGb", // Changes to be made here.
  reposLength: 0,
  specificRepos: [
    "My-Reads",
    "e-commerce",
    "Would_You_Rather_Game",
    "Movie-App",
  ],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../editable-stuff/shadowProfile.jpg"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
    },
    {
      img: require("../editable-stuff/shadowProfile.jpg"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
    },
  ],
  imageSize: {
    width: "615",
    height: "450",
  },
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "React-JS", value: 85 },
    { name: "Next Js", value: 85 },
    { name: "JavaScript", value: 90 },
    { name: "CSS - Tailwind - Styled-Components - MUI", value: 85 },
    { name: "Word Press", value: 70 },
    { name: "HTML", value: 80 },
    { name: "Nest Js", value: 75 },
    { name: "Node Js", value: 85 },
    { name: "Express", value: 80 },
    { name: "Mongo DB", value: 70 },
    { name: "Typescript", value: 75 },
    { name: "Postgres SQL", value: 75 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm constantly searching for software development job opportunities! If you know of any positions available or you have any questions for me, please feel free to email me at",
  email: "muhammad17gb@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: "Software Engineer", // Here Add Company Name
      companylogo: require("../assets/img/dell.png"),
      date: "January 2021 – Present",
    },
    {
      role: "Front-End Developer",
      companylogo: require("../assets/img/boeing.png"),
      date: "December 2020 – Present",
    },
  ],
};

// Blog SECTION
// const blog = {
//   show: false,
// };

export {
  navBar,
  mainBody,
  about,
  repos,
  skills,
  leadership,
  getInTouch,
  experiences,
};
